import ApiService from "services/ApiService";

export const getLabelsByProject = async (projectId) => {
    const res = await ApiService.get(`/label/project/${projectId}`);
    return res;
};

export const createLabel = async ({ project_id, value }) => {
    const res = await ApiService.post(`/label/project`, { project_id, value });
    return res;
};

export const findLabelByValue = async (projectId, value) => {
    const res = await ApiService.get(`/label/project/${projectId}/search?value=${value}`);
    return res;
};

export const getLabelsForTestCase = async (testCaseId) => {
    const res = await ApiService.get(`/label/test-cases/${testCaseId}`);
    return res;
};

export const assignLabelToTestCase = async (testCaseId, labelId) => {
    const res = await ApiService.post(`/label/test-cases/${testCaseId}`, {
        label_id: labelId,
    });
    return res;
};

export const removeLabelFromTestCase = async (testCaseId, labelId) => {
    const res = await ApiService.delete(`/label/test-cases/${testCaseId}/${labelId}`);
    return res;
};
